/* DSY Studios Theme JS */

// Mobile menu toggle
document.addEventListener('DOMContentLoaded', function () {
  const menuBtn = document.querySelector('.mobile-menu-btn');
  const nav = document.querySelector('.site-nav');
  if (menuBtn && nav) {
    menuBtn.addEventListener('click', function () {
      nav.classList.toggle('nav-open');
    });
  }

  // Quantity buttons on product page
  document.querySelectorAll('.qty-btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      const input = this.parentElement.querySelector('.qty-input');
      let val = parseInt(input.value) || 1;
      if (this.dataset.action === 'minus') val = Math.max(1, val - 1);
      if (this.dataset.action === 'plus') val = val + 1;
      input.value = val;
    });
  });

  // Variant selection
  document.querySelectorAll('.variant-btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      this.closest('.variant-options').querySelectorAll('.variant-btn').forEach(b => b.classList.remove('selected'));
      this.classList.add('selected');
    });
  });
});
